import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

type THeadingProps = React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
>;

// m-0 is needed to override the pandora css reset

export const H1 = ({ children, className, ...props }: THeadingProps) => {
    return (
        <h1
            className={twMerge(
                classNames(
                    'm-0 text-2xl text-primary-10 min-m:text-3xl',
                    className
                )
            )}
            {...props}
        >
            {children}
        </h1>
    );
};

export const H2 = ({ children, className, ...props }: THeadingProps) => {
    return (
        <h2
            className={twMerge(
                classNames(
                    'm-0 text-xl text-primary-10 min-m:text-2xl',
                    className
                )
            )}
            {...props}
        >
            {children}
        </h2>
    );
};

export const H3 = ({ children, className, ...props }: THeadingProps) => {
    return (
        <h3
            className={twMerge(
                classNames('m-0 text-xl text-primary-10', className)
            )}
            {...props}
        >
            {children}
        </h3>
    );
};
